/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2018 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
import { inject } from "mobx-react";
import * as pageSelectors from "selectors/pageSelectors";
import { getMargin } from "selectors/zoom";
import { PageView } from "components/document/page/PageView";
import { PAGE_MARGIN_BOTTOM } from "constants/constants";
import { getViewRotationAngle } from "selectors/documentSelectors";
import { PageCanvasContainer } from "containers/document/page/PageCanvasContainer";
import { getViewPortWidthWithoutPagesViewScrollbar } from "selectors/documentViewSelectors";
import { recordTimeToViewFirstPage } from "utils/performance";
import { getHideStickyToolOnTap } from "selectors/appSelectors";
import { isDarkPageThemeEnabled } from "selectors/appSelectors";
import { withTheme } from "context/themeContext";

const pageOverlays = [PageCanvasContainer];

function mapStoreToProps(stores, ownProps) {
  return {
    pageBitmap: pageSelectors.getPageBitmap(stores, ownProps.pageIndex),
    height: pageSelectors.getPageHeight(stores, ownProps.pageIndex),
    width: pageSelectors.getPageWidth(stores, ownProps.pageIndex),
    pageIndex: ownProps.pageIndex,
    overlays: ownProps.loadNonPDFPageCanvas ? pageOverlays : [],
    loadNonPDFPageCanvas: ownProps.loadNonPDFPageCanvas,
    viewRotationAngle: getViewRotationAngle(stores),
    viewportWidth: getViewPortWidthWithoutPagesViewScrollbar(stores),
    pageMarginBottom: PAGE_MARGIN_BOTTOM,
    margins: getMargin(stores),
    setPageHandle: pageHandle => {
      stores.documentStore.setPageHandle(pageHandle, ownProps.pageIndex);
    },
    onFirstPageRendered: () => {
      recordTimeToViewFirstPage();
      stores.pagedViewState.setIsInitialPageRendered(true);
    },
    hideStickyToolOnTap: getHideStickyToolOnTap(stores),
    toggleStickyToolPanel: () => stores.stickyToolsStore.toggleStickyToolPanel(),
    invertColors: isDarkPageThemeEnabled(stores)
  };
}

const NonPDFPageContainer = inject(mapStoreToProps)(withTheme(PageView));

export { NonPDFPageContainer };
